module.exports = __webpack_public_path__ + "img/Frame_46.b303a1c0.png";